import { render, staticRenderFns } from "./SDASelectedProducts.vue?vue&type=template&id=6efa9ce7"
import script from "./SDASelectedProducts.vue?vue&type=script&lang=js"
export * from "./SDASelectedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports